<script setup lang="js">
import { ElCollapseItem, ElInput, ElCheckbox, ElDatePicker, ElButton,ElSwitch } from 'element-plus';
import { ref, defineProps } from 'vue'
import { useProductStore } from '../../../stores/fpe';
import { storeToRefs } from 'pinia';
import { ArrowRightBold, ArrowDownBold, ArrowUpBold } from '@element-plus/icons-vue'
    
    const store = useProductStore();
    const { product, data_sets, tax_enabled, strings, selectedVariationDetails } = storeToRefs(store);


</script>
<template>
    <el-collapse-item :title="strings.section_title_inventory" class="fpe-section-inventory" name="variation-inventory" :icon="ArrowRightBold"> 
        <div class="fpe-field-wrapper fpe-inline-switcher fpe-manage-stocks"  data-field="manage-stocks">
            <label>{{ strings.label_manage_stocks }}
                <Info :tooltip_text="strings.tooltip_manage_stocks" />
            </label>
            <ElSwitch v-model="selectedVariationDetails.manage_stocks" />
        </div>      
        <div class="fpe-field-wrapper" v-if="selectedVariationDetails.manage_stocks" data-field="stock-quantity">
            <label>{{ strings.label_stock_quantity }}</label>
            <ElInputNumber v-model="selectedVariationDetails.stock_quantity" controls-position="right" align="left">
                <template #increase-icon>
                    <el-icon>
                        <ArrowUpBold />
                    </el-icon>
                </template>
                <template #decrease-icon>
                    <el-icon>
                        <ArrowDownBold />
                    </el-icon>
                </template>
            </ElInputNumber>    
        </div>
        <div class="fpe-field-wrapper" v-if="selectedVariationDetails.manage_stocks" data-field="backorders">
            <label>{{ strings.label_allow_backorders }}</label>
            <ElSelect v-model="selectedVariationDetails.backorders">
                <ElOption
                    v-for="(value, name) in Object.entries(data_sets.backorder_options)"
                    :key="value[0]"
                    :label="value[1]"
                    :value="value[0]"
                />
            </ElSelect>
        </div>

        <div class="fpe-field-wrapper" v-if="selectedVariationDetails.manage_stocks" data-field="low-stock-amount">
            <label>{{ strings.label_low_stock_threshold }} 
                <Info :tooltip_text="data_sets.low_stock_threshold" />
            </label>
            <ElInputNumber
                v-model="selectedVariationDetails.low_stock_amount" 
                controls-position="right"
                align="left"
                min="0"
                
            ><template #increase-icon>
                    <el-icon>
                        <ArrowUpBold />
                    </el-icon>
                </template>
                <template #decrease-icon>
                    <el-icon>
                        <ArrowDownBold />
                    </el-icon>
                </template>
            </ElInputNumber>        
        </div>

        <div class="fpe-field-wrapper" data-field="stock-status" v-if="!selectedVariationDetails.manage_stocks">
            <label>{{ strings.label_stock_status }}</label>
            <ElSelect v-model="selectedVariationDetails.stock_status" :suffix-icon="ArrowDownBold">
                <ElOption
                    v-for="(value, name) in Object.entries(data_sets.stock_statuses)"
                    :key="value[0]"
                    :label="value[1]"
                    :value="value[0]"
                />
            </ElSelect>
        </div>
    </el-collapse-item>
</template>